(function(){
    'use strict'

    angular
    .module('app.deducibles')
    .controller('OtrosDeducibles', OtrosDeducibles);

    OtrosDeducibles.$inject = ['$animationsSrv', 'DeduciblesService', 'logger', '$location', 'UserInfoService'];

    function OtrosDeducibles($animationsSrv, DeduciblesService, logger, $location, UserInfoService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.deducibles = [];
        vm.title = 'Deducibles';

        vm.goToEdit = function(deducible){
            
            var path = '/editar-otro-deducible/';

            if(deducible){
                $location.path(path + deducible.id);
            }
            else{
                $location.path(path);
            }
            
        };

        vm.openModal = function(modalName){
            $(modalName).modal('toggle');    
        };

        getAll();

        function getAll(){

            var promise = DeduciblesService.getAllOtros();

            promise
            .then(function(deducibles){
                vm.deducibles = deducibles;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener los deducibles.');
                        break;
                }
            });
        };

        vm.delete = function(deducible){
            var promise = DeduciblesService.removeOtros(deducible);
            
            promise
            .then(function(response){
                vm.deducibles = vm.deducibles.filter(function(g) {
                    return g.id !== deducible.id;
                });
                logger.success('Deducible eliminada con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un error al eliminar la Deducible');
                        break;
                }
                
            });   
        };

    }
})();